import React from 'react';
import styled from 'styled-components';

const Header = styled.div`
	margin-bottom: 10px;

	p {
		margin: 0;
	}

  @media(min-width: 768px) {
    div {
      width: 100%;
      display: inline-block;

    	p {
	      &:first-child {
	        float: left;
	      }

	      &:nth-child(2) {
	        float: right;
	      }
	    }
	  }
  }
`;

class HeaderContent extends React.Component {
  render() {
    return (
    	<Header>
	      <div>
	        <p> <b> {this.props.title} </b> </p>
	        <p> <i> {this.props.date} </i> </p>
	      </div>
  			<p>{this.props.role}</p>
    	</Header>
    );
  }
}

export default HeaderContent;



// WEBPACK FOOTER //
// ./src/components/HeaderContent.js